module.exports = Stripe;